import MuiAccordion from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  '&:before': {
    display: 'none'
  },
  '&:not(:last-child)': {
    borderBottom: 0
  },
  border: `1px solid ${theme.palette.divider}`
}));

export default Accordion;
